import { Injectable, inject } from '@angular/core';
import { ApiGatewayService, API_GATEWAY_CONFIG, ApiGatewayConfig } from '@drc-eca/eca-components-lib';
import { Observable } from 'rxjs';
import { SearchCriteria, SortService } from '../../util/sort.service';
import { IStatusType } from '../../model/common.model';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../services/notification.service';
@Injectable({
  providedIn: 'root'
})
export class ClientStatusService {
  config = inject<ApiGatewayConfig>(API_GATEWAY_CONFIG, { optional: true })!;
  private apiGatewaySvc = inject(ApiGatewayService);
  private http = inject(HttpClient);
  private sortService = inject(SortService);
  private notificationService = inject(NotificationService);

  constructor() {}

  getServiceName () {
   return `${this.config['lambdaServiceUrl']}`;
  }

  doGet(path: string, options: any = {}) {
    const opts = this.getOptions();
    
    // For public endpoints (no token), use HttpClient directly to bypass ECA auth interceptors
    if (!opts.includeToken) {
      return this.http.get(`${this.getServiceName()}/${path}${options.query? options.query : ''}`);
    }
    
    return this.apiGatewaySvc.get(`${this.getServiceName()}/${path}${options.query? options.query : ''}`, opts);
  }

  doPost (path: string, data: any) {    
    return this.apiGatewaySvc.post(`${this.getServiceName()}/${path}`, data, this.getOptions());
  }

  doPut (path: string, data: any) {    
    return this.apiGatewaySvc.put(`${this.getServiceName()}/${path}`, data, this.getOptions());
  }

  doDelete (path: string, id: string) {
    return this.apiGatewaySvc.delete(`${this.getServiceName()}/${path}/${id}`, this.getOptions());
  }

  getServiceStatusList(): Observable<IStatusType[]>{
    //return ['Normal Operations', 'Degraded Performance', 'Partial Outage', 'Major Outage', 'Maintenance' ];
    return this.apiGatewaySvc.get(`${this.getServiceName()}/admin/status`, this.getOptions());
  }

  getServiceStateList(){
    return ['Investigating', 'Identified', 'Monitoring', 'Resolved'];
  } 

  getClass = (name: string) => {
    switch (name) {
      case 'Normal Operations': {
        return 'operational';
      }
      case 'Partial Outage': {
        return 'partialoutage';
      }
      case 'Investigating':{
        return 'majoroutage';
      }
      case 'Identified':{
        return 'partialoutage';
      }
      case 'Monitoring':{
        return 'monitoring';
      }
      case 'Resolved':{
        return 'resolved';
      }
      case 'Major Outage':{
        return 'majoroutage';
      }
      default : {
        return 'degraded';
      }
    }
  }

  private getOptions(){     
    // Only include token if user is authenticated and token is valid (not null/empty)
    const token = sessionStorage.getItem('ngStorage-ecatoken');
    const hasToken = token != null && token !== 'null' && token !== '';
    
    const options: any = {
      httpOptions : {
        headers : {
          'authsource': sessionStorage.getItem('localSecurityOn') === 'true' ? 'local' : 'eca-security-service'
        }
      },
      includeToken: hasToken,
      withCredentials: false
    };

    return options;
  }

  sortArray(data:any[], sortColumn: string, sortDirection = 'asc'){
    const criteria: SearchCriteria = new SearchCriteria();
    criteria.sortColumn = sortColumn;
    criteria.sortDirection = sortDirection;
    return this.sortService.sort(criteria, data);
  }

  showSuccess(inMessage: string) {
    this.notificationService.showSuccess(inMessage);
  }

  showWarning(inMessage: string, error: any = null) {
    const message = `${inMessage}${error != null ? ' ' + error : ''}`;
    this.notificationService.showWarning(message);
  }


}

